export const environment = {
  "gateway": {
    "host": "https://sandbox.open.gerpgo.com"
  },
  "headers": {
    "g-origin": "https://admin.sandbox.open.gerpgo.com/"
  },
  "branch": "sandbox",
  "tag": "release-v1.0.0"
}